import React, { ReactNode } from 'react';
import Button from '../Button';

import * as S from './styles';

export type ModalProps = {
  visible: boolean;
  onClose: () => void;
  children: ReactNode;
  withoutCloseButton?: boolean;
  buttonClosePrimary?: boolean;
  isFull?: boolean;
  name?: string;
};

const Modal = ({
  visible,
  onClose,
  children,
  withoutCloseButton = false,
  buttonClosePrimary,
  isFull,
  ...rest
}: ModalProps) => {
  return (
    <S.Container
      visible={visible}
      // onClick={() => {
      //   onClose();
      // }}
    >
      <S.Overlay aria-hidden={!visible} aria-label="overlay" visible={visible} onClick={onClose} isFull={isFull} />
      <S.Modal visible={visible} isFull={isFull} {...rest} onClick={() => {}}>
        {children}
        {!withoutCloseButton && (
          <S.CloseWrapper>
            <Button title="Fechar" type="button" tertiary={!buttonClosePrimary} onClick={onClose} />
          </S.CloseWrapper>
        )}
      </S.Modal>
    </S.Container>
  );
};

export default Modal;
